var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { attrs: { "data-qa": "price_clinic" } }, [
    _c(
      "div",
      {
        staticClass: "text-h6 text--text mb-1",
        attrs: { "data-qa": "price_clinic_num" },
      },
      [_vm._v("\n    " + _vm._s(_setup.getFormattedPrice(_vm.price)) + "\n  ")]
    ),
    _vm._v(" "),
    _vm.price
      ? _c(
          "div",
          {
            staticClass: "text-caption text-secondary--text",
            attrs: { "data-qa": "price_clinic_desc" },
          },
          [
            _vm._v(
              "\n    " +
                _vm._s(_setup.t("Оплата в клинике", _setup.options)) +
                "\n  "
            ),
          ]
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }